import { render, staticRenderFns } from "./DataMapOverview.vue?vue&type=template&id=132cb8cf"
import script from "./DataMapOverview.vue?vue&type=script&lang=js"
export * from "./DataMapOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports